webpackJsonp([178698757827068],{

/***/ 377:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"jackyzhen.com","subtitle":"A Software Developer living in Auckland, NZ","menu":[{"label":"Ramblings","path":"/"},{"label":"About","path":"/about/"},{"label":"Resume","path":"/resume.pdf"}],"author":{"name":"Jacky Zhen","email":"me@jackyzhen.com","github":"jackyzhen","linkedin":"jacky-shunjie-zhen-5b735042","rss":"https://jackyzhen.com/rss.xml"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---404-html-1494c28b476ff2069d3c.js